import { httpClient } from 'app/api/http/http-client';
import { Feedback, FeedbackResponse } from 'app/providers/csi/model/types';

export const leaveFeedback = async (data: Feedback): Promise<FeedbackResponse> => {
  return await httpClient.post(
    `/api-web/v1/main/${data.endpoint}?business_key=${data.business_key}`,
    {
      rating: data.rating,
      comment: data.comment,
    }
  );
};
